import axios, { AxiosPromise } from 'axios';

export interface IUdaje {
    jmeno: string;
    prijmeni: string;
    telefon: string;
}
const zmenaUdajuApi = (data: IUdaje, lang: string): AxiosPromise => {
    return axios({
        method: 'POST',
        url: 'Portal/ZmenaUdaju',
        data: {
            ...data,
            lang
        }
    });
};

export default zmenaUdajuApi;
